var _excluded = ["alt", "frame", "height", "src", "width"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
var StyledImage = styled.img.withConfig({
  componentId: "CL__sc-1ckctc7-0"
})(["border:none;border-radius:", ";display:block;"], _ref => {
  var {
    frame
  } = _ref;
  return frame === 'rounded' ? '24px' : frame === 'bub' ? '24px 24px 24px 0' : frame === 'bub-reverse' ? '24px 24px 0 24px' : '0';
});
var Image = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
      alt,
      frame = 'square',
      height = 'auto',
      src,
      width = '100%'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledImage, _extends({
    alt: alt,
    frame: frame,
    height: height,
    ref: ref,
    src: src,
    width: width
  }, props));
});
export default Image;